module.exports = __webpack_public_path__ + "static/InvoicingAndAccounting-f1e1a62d869d3bdbb24c6862e4543e3f.svg";